"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mail-in-a-Box
 * Mail-in-a-Box API HTTP specification.
 *
 * The version of the OpenAPI document: 0.47.0
 * Contact: contact@mailinabox.email
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailUsersResponseFormatToJSON = exports.MailUsersResponseFormatFromJSONTyped = exports.MailUsersResponseFormatFromJSON = exports.MailUsersResponseFormat = void 0;
/**
 * Response format (`application/json` or `text/html`).
 * @export
 * @enum {string}
 */
var MailUsersResponseFormat;
(function (MailUsersResponseFormat) {
    MailUsersResponseFormat["Text"] = "text";
    MailUsersResponseFormat["Json"] = "json";
})(MailUsersResponseFormat = exports.MailUsersResponseFormat || (exports.MailUsersResponseFormat = {}));
function MailUsersResponseFormatFromJSON(json) {
    return MailUsersResponseFormatFromJSONTyped(json, false);
}
exports.MailUsersResponseFormatFromJSON = MailUsersResponseFormatFromJSON;
function MailUsersResponseFormatFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MailUsersResponseFormatFromJSONTyped = MailUsersResponseFormatFromJSONTyped;
function MailUsersResponseFormatToJSON(value) {
    return value;
}
exports.MailUsersResponseFormatToJSON = MailUsersResponseFormatToJSON;
